import { render, staticRenderFns } from "./stateRoom.vue?vue&type=template&id=0b7fbef2&scoped=true&"
import script from "./stateRoom.vue?vue&type=script&lang=js&"
export * from "./stateRoom.vue?vue&type=script&lang=js&"
import style0 from "./stateRoom.vue?vue&type=style&index=0&id=0b7fbef2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7fbef2",
  null
  
)

export default component.exports